import React from 'react';
import DocumentActionIcon from '../common/DocumentActionIcon';

export type AnnualTimetableClassActionBarProps = {
  gradeId: string;
  hasScheduleEntry: boolean;
  loading: boolean;
  loadingCells: boolean;
  operationPlanDisabled: boolean;
  onOpenOperationPlan: (gradeId: string) => void;
  onOpenEventModal: (gradeId: string) => void;
  onOpenManageFixedModal: () => void;
  onOpenShortDayModal: (gradeId: string) => void;
  onOpenManageShortDayModal: () => void;
};

const AnnualTimetableClassActionBar: React.FC<AnnualTimetableClassActionBarProps> = ({
  gradeId,
  hasScheduleEntry,
  loading,
  loadingCells,
  operationPlanDisabled,
  onOpenOperationPlan,
  onOpenEventModal,
  onOpenManageFixedModal,
  onOpenShortDayModal,
  onOpenManageShortDayModal,
}) => {
  const busy = loading || loadingCells;
  const noEntry = !hasScheduleEntry;

  return (
    <div className="cp-annual-class-block-actions" role="toolbar" aria-label="연간시간표 클래스 작업">
      <div className="cp-annual-top-actions-main">
        <div className="cp-annual-action-group" role="group" aria-label="고정 프로그램">
          <button
            type="button"
            className="cp-btn-annual-action cp-btn-annual-action-with-program-mark"
            onClick={() => onOpenEventModal(gradeId)}
            disabled={busy || noEntry}
          >
            <span
              className="cp-class-record-memos-program-mark cp-class-record-memos-program-mark--fixed"
              aria-hidden
            />
            <span className="cp-annual-action-label-full">고정 프로그램(행사) 등록</span>
            <span className="cp-annual-action-label-compact">고정P 등록</span>
          </button>
          <button
            type="button"
            className="cp-btn-annual-action cp-btn-annual-action-with-program-mark"
            onClick={onOpenManageFixedModal}
            disabled={busy || noEntry}
          >
            <span
              className="cp-class-record-memos-program-mark cp-class-record-memos-program-mark--fixed"
              aria-hidden
            />
            <span className="cp-annual-action-label-full">고정 프로그램 관리</span>
            <span className="cp-annual-action-label-compact">고정P 관리</span>
          </button>
        </div>
        <div className="cp-annual-action-group" role="group" aria-label="증배 및 단축일">
          <button
            type="button"
            className="cp-btn-annual-action"
            onClick={() => onOpenShortDayModal(gradeId)}
            disabled={busy || noEntry}
          >
            <span className="cp-annual-action-label-full">증배 및 단축일 등록</span>
            <span className="cp-annual-action-label-compact">증배 단축일 등록</span>
          </button>
          <button
            type="button"
            className="cp-btn-annual-action"
            onClick={onOpenManageShortDayModal}
            disabled={busy || noEntry}
          >
            <span className="cp-annual-action-label-full">증배 및 단축일 관리</span>
            <span className="cp-annual-action-label-compact">증배 단축일 관리</span>
          </button>
        </div>
      </div>
      <div className="cp-annual-class-block-actions-trailing">
        <button
          type="button"
          className="cp-btn-annual-action cp-btn-annual-action-operation-plan cp-btn-annual-action-with-document-icon"
          onClick={() => onOpenOperationPlan(gradeId)}
          disabled={busy || noEntry || operationPlanDisabled}
        >
          <DocumentActionIcon />
          연간 수업 일수 및 시수 운영계획
        </button>
      </div>
    </div>
  );
};

export default AnnualTimetableClassActionBar;
